/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { IdentityServerApiConfig } from '../api-config';

import { IdentityServerApi } from '../models';

@Injectable()
export class SettingsApiClient extends BaseApiClient<IdentityServerApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.identityServerApiConfig);
  }

  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  userSettingsControllerPutApiIdentitySettingsByuserId(
    params: { body: IdentityServerApi.UpdateUserSettingsRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<any>(
      `${this.basePath}/gateway/admin/settings/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.ResponseSettingsByUserId>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.ResponseSettingsByUserId>>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.ResponseSettingsByUserId>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.ResponseSettingsByUserId>>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.ResponseSettingsByUserId>>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.ResponseSettingsByUserId>>;
  userSettingsControllerPostApiIdentitySettingsByuserId(
    params: { body: Array<string>; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<IdentityServerApi.ResponseSettingsByUserId>(
      `${this.basePath}/gateway/admin/settings/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
